// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-label {
  white-space: normal !important;
}`, "",{"version":3,"sources":["webpack://./src/components/general components/popover-object-info/popover-object-info.component.scss","webpack://./src/components/general%20components/popover-object-info/popover-object-info.component.scss"],"names":[],"mappings":"AAAA;EACI,8BAAA;ACCJ","sourcesContent":["ion-label {\n    white-space: normal !important;\n}","ion-label {\n  white-space: normal !important;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
